module.exports = __webpack_public_path__ + "img/bonds of blood.a53ae47e.png";